/* eslint-disable react/prop-types */

import axios from "axios"

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Table from "examples/Tables/Table";
import Icon from "@mui/material/Icon";
import Link from "@mui/material/Link";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";
import SoftAvatar from "components/SoftAvatar";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PermissionNavbar from "examples/Navbars/PermissionNavbar";

import Header from "layouts/izinler/Header";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faHouse, faPenToSquare, faTrash } from '@fortawesome/free-solid-svg-icons'

import BasicModal from 'components/SoftModal';
import ModalIndex from 'layouts/form/modal';


function Tables() {



  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  const handleModalOpen = (index) => {
    setModalContent(index);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };


  const navigate = useNavigate();
  //const [data, setData] = useState([]);
  const currentYear = 100;
  const [selectedYear, setSelectedYear] = useState(currentYear);

  const [isLoading, setIsLoading] = useState(false);
  const allString = "TÜMÜ";


  const truncatedTextStyle = {
    width: '250px',
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 1,
    height: '20px',
    WebkitBoxOrient: 'vertical'
  };

  const [data, setData] = useState([]);

  const changeYear = (amount) => {
    if (selectedYear !== allString) {
      setSelectedYear((prevYear) => prevYear + amount);
    }
  };

  const YearAllChange = () => {

    if (selectedYear === allString) {
      setSelectedYear(currentYear);
    }
    else{
      setSelectedYear(allString);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        if (selectedYear === allString) {
          const response = await axios.get(`${window.BASE_URL}/model-fields-logs/Izinler?format=json`, { withCredentials: true });
          setData(response.data);
        }
        else {
         const response = await axios.get(`${window.BASE_URL}/model-fields-logs/Izinler/${selectedYear}?format=json`, { withCredentials: true });
         setData(response.data);
        }
        setData(response.data);
      } catch (error) {
        console.log(error);
      }
      finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [selectedYear]);


  const [dataLog, setDataLog] = useState([]);

  useEffect(() => {
    if (!modalContent) return;
    const fetchData = async () => {
      try {
        const response = await axios.get(`${window.BASE_URL}/model-fields-log/${"Izinler"}/${modalContent}`, {
          withCredentials: true
        });
        setDataLog(response.data);
      } catch (error) {
        console.log(error);

      }
    };

    fetchData();
  }, [modalContent]);

  let egitimRows = Array.isArray(data?.logs) ? data.logs.map(index => ({
    "Yetkili": [
      <img key="" src="12" alt="Logo" />,
      <span key="task1" style={truncatedTextStyle}> {index.user.name + " " + index.user.surname}  </span>,
    ],

    "Referans No": <SoftTypography variant="caption" color="text" fontWeight="medium">{index.instance_id}</SoftTypography>,

    "Eylem": <SoftBadge variant="gradient" badgeContent={index.action == "create" ? "Yenİ Kayıt" : index.action == "update" ? "Güncelleme" : "Silme"} color={index.action == "create" ? "info" : index.action == "update" ? "light" : "dark" } size="xs" container />,
  
    "Tarih": <SoftTypography variant="caption" color="text" fontWeight="medium">{index.timestamp}</SoftTypography>,
  
    "İzin Türü": <SoftTypography variant="caption" color="text" fontWeight="medium">{index.izin_turu} </SoftTypography>,
  
    "Düzenleyen": [
      <a key="" />,
      <span style={truncatedTextStyle} key="task2" > {index.duzenleyen_kisi ? index.duzenleyen_kisi?.name + " " + index.duzenleyen_kisi?.surname : ""}  </span>
    ],
  
    "Düzenlenme Tarihi": <SoftTypography variant="caption" color="text" fontWeight="medium">{index.talep_tarihi}</SoftTypography>,
  
    "Talep Şekli": <SoftTypography variant="caption" color="text" fontWeight="medium">{index.talep_sekli}</SoftTypography>,
  
    "Onaylayan / Reddeden": [
      <a key="" />,
      <span style={truncatedTextStyle} key="task2" > {index.talep_edilen ? index.talep_edilen?.name + " " + index.talep_edilen?.surname : ""}  </span>
    ],
  
    "Detaylar": <>
      <SoftTypography component="a" onClick={() => handleModalOpen(index?.instance_id)} variant="caption" color="secondary" fontSize="medium" > 
        <FontAwesomeIcon icon={faEye} />
      </SoftTypography>
      
    </>,
  
    "field_username": index.user.name + " " + index.user.surname,
    "field_gun": index.action,
    "field_tarih": index.tarih,
  })) : [];

  const projectsTableData = {
    columns: [
      { name: "Yetkili", align: "left", exportableField: "field_username", searchable: true, searchField: ["field_username"] },
      { name: "Referans No", align: "center", exportableField: "field_gun", searchable: true, searchField: ["field_gun"] },
      { name: "Eylem", align: "center", exportableField: "field_gun", searchable: true, searchField: ["field_gun"] },
      { name: "Tarih", align: "center", exportableField: "field_tarih", searchable: true, searchField: ["field_tarih"] },

      { name: "Detaylar", align: "center" },
      //{ name: "Durum", align: "left" },

    ],

    rows: [
      ...egitimRows,

    ],
  };











  return (

    <Grid item xs={12} md={12} xl={12}>
      <BasicModal open={modalOpen} handleClose={handleModalClose} content={modalContent} contentCode={<ModalIndex logsData={dataLog} />} />
      <SoftBox display="flex" justifyContent="flexStart" gap={2} alignItems="center" flexDirection="row-reverse" p={3} >

        <SoftButton variant="gradient" color="info" onClick={() => YearAllChange()} disabled={isLoading}>
        <Icon style={{marginRight:"5px"}}>list</Icon>
          <a style={{fontSize:"0.9rem"}}> {selectedYear > 0 ? "SON "+ selectedYear: selectedYear} </a>
          
        </SoftButton>

      </SoftBox>

      <Card>
        <SoftBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
          <SoftTypography variant="h6">Yıllık İzinler Listesi</SoftTypography>
        </SoftBox>
        <SoftBox
          sx={{
            "& .MuiTableRow-root:not(:last-child)": {
              "& td": {
                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                  `${borderWidth[1]} solid ${borderColor}`,
              },
            },
          }}
        >
          <Table columns={projectsTableData.columns} rows={projectsTableData.rows} isLoading={isLoading} />
        </SoftBox>
      </Card>

    </Grid>


  );

}

export default Tables;
